


































import { defineComponent, PropType } from '@vue/composition-api';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import SimpleInputSection from '@front-app/components/form/SimpleInputSection.vue';
import TrForm from '@front-app/components/form/Form.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { CommunityWithGroups } from '@front-app/services/CommunityApi/CommunityModel';
import { required } from '@front-app/components/form/validation/validators';
import { Size, Spacing } from '@front-app/components/constants';
import { syncedRef } from '@front-app/util/reactivity';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { useCommunitiesStore } from '@front-app/store/piniaModules/communities';
import { useFocusFirstInvalidField } from '@front-app/hooks/useFocusFirstInvalidField';
import { v } from '@front-app/components/form/validation/useValidation';

export default defineComponent({
	components: {
		CtaButton,
		ErrorCard,
		SimpleInputSection,
		TrForm,
	},
	props: {
		community: {
			type: Object as PropType<CommunityWithGroups>,
			required: false,
			default: null,
		},
	},
	setup(props, ctx) {
		const communitiesStore = useCommunitiesStore();

		const name = syncedRef(() => props.community.name).ref;

		// Validation
		const validation = v({
			name: {
				value: name,
				rules: [required()],
			},
		});

		const { focusFirstInvalid } = useFocusFirstInvalidField({ containerSelector: '.edit-community-name-form' });
		// End validation

		// Submit
		const {
			track,
			isLoading,
			isError,
			isSuccess,
		} = useAsyncStatus();

		const updateName = async () => {
			validation.validate();
			if (!validation.isValid.value) {
				focusFirstInvalid();
				return;
			}

			await track(communitiesStore.saveCommunityUpdates(props.community.id, { name: name.value }));

			if (isSuccess.value) {
				ctx.emit('close');
			}
		};
		// END Submit

		return {
			name,
			validation,
			updateName,
			isLoading,
			isError,
			// Util
			ButtonPalettes,
			Size,
			Spacing,
		};
	},
});
